var React = require('react');
var labels = require('MemberJoinLabels');
var SaveAndExitButton = require('./SaveAndExitButton.jsx');
const { constant } = require('lodash');
class Cart extends React.Component {
    constructor(props) {
        super(props);

        this.handleOptOutChange = this.handleOptOutChange.bind(this);
    }

    handleOptOutChange(event) {
        this.props.updateApplicationState('stateComponentDuesOptOut', event.target.checked);
    }

    render() {
        if (this.props.appState.currentStep < 3) {
            return null;
        }
        const current = new Date();
        var optOutClass = this.props.appState.stateComponentDuesOptOut ? ' opted-out' : '';
        const optOut = this.props.appState.stateComponentDues > 0 && this.props.appState.stateComponentDuesOptOutEligible ? <div className={"state-component-opt-out"}><input type="checkbox" id="optoutcart" onChange={this.handleOptOutChange} checked={this.props.appState.stateComponentDuesOptOut} /><label className={"opt-out-label"} htmlFor={"optoutcart"}><small>{labels.cart.optOut}</small></label></div> : null;
        const stateLabel = this.props.appState.primaryPracticeLocation ? ' (' + this.props.appState.primaryPracticeLocation + ')' : '';
        const districtLabel = this.props.appState.primaryDistrictLocation ? ' (' + this.props.appState.primaryDistrictLocation + ')' : '';
        if ((this.props.appState.productType && this.props.appState.productType.startsWith("EC") &&
            this.props.appState.productType.charAt(this.props.appState.productType.length - 1) == 1 ||
            this.props.appState.productType.charAt(this.props.appState.productType.length - 1) == 2 ||
            this.props.appState.productType.charAt(this.props.appState.productType.length - 1) == 3))
        {
            if (this.props.appState.yearsInPractice == undefined && this.props.appState.yearsInPractice == null && typeof this.props.appState.yearsInPractice !== 'number') {
                this.props.appState.yearsInPractice = this.props.appState.productType.charAt(this.props.appState.productType.length - 1);
            }
           
        }
        //console.log("YIP=" + this.props.appState.yearsInPractice);
        //console.log("RateCode=" + this.props.appState.rateCode);
        //console.log("ProductType=" + this.props.appState.productType);      
        const stateComponentTermMarkup = !this.props.appState.productType ? null :
            !(this.props.appState.productType && this.props.appState.productType.startsWith("EC")) ? null :
                !this.props.appState.yearsInPractice
                    ? (!this.props.appState.rateType ? null
                        : ((this.props.appState.rateType.charAt(this.props.appState.rateType.length - 1) == "1" ||
                            this.props.appState.rateType.charAt(this.props.appState.rateType.length - 1) == "2" ||
                            this.props.appState.rateType.charAt(this.props.appState.rateType.length - 1) == "3") ?
                            <div className={"row" + optOutClass}>
                                <div className={"col-md-12"}>
                                    <div className={"desc"}>
                                        <span>For Term: {current.getMonth() + 1}/{current.getDate()}/{current.getFullYear()} -
                                            12/31/{current.getFullYear()}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            : null)) : ((this.props.appState.yearsInPractice == 1 ||
                                this.props.appState.yearsInPractice == 2 ||
                                this.props.appState.yearsInPractice == 3) ?
                                <div className={"row" + optOutClass}>
                                    <div className={"col-md-12"}>
                                        <div className={"desc"}>
                                            <span>For Term: {current.getMonth() + 1}/{current.getDate()}/{current.getFullYear()} -
                                                12/31/{current.getFullYear()}
                                            </span>
                                        </div>
                                    </div>
                                </div> : null);

        const stateComponentMarkup = this.props.appState.isInternational || !this.props.appState.stateParticipating
            ? null
            : <div className={"item"}>
                <div className={"row" + optOutClass}>
                    <div className={"col-md-8"}>
                        <div className={"desc"}>
                            <label htmlFor={"optoutcart"} className={"line1 state-component-label"}>{labels.cart.stateComponentDues + stateLabel}</label>
                        </div>
                    </div>
                    <div className={"col-md-4"}>
                        <div className={"cost"}>
                            <span>${parseFloat(this.props.appState.stateComponentDues)}</span>
                        </div>
                    </div>
                </div>
                {stateComponentTermMarkup}
                {optOut}
            </div>;
        const districtDuesMarkup = !this.props.appState.districtParticipating
            ? null
            : <div className={"item"}>
                <div className={"row" + optOutClass}>
                    <div className={"col-md-8"}>
                        <div className={"desc"}>
                            <label htmlFor={"optoutcart"} className={"line1 state-component-label"}>{"District Dues " + districtLabel}</label>
                        </div>
                    </div>
                    <div className={"col-md-4"}>
                        <div className={"cost"}>
                            <span>${parseFloat(this.props.appState.districtDues)}</span>
                        </div>
                    </div>
                </div>
            </div>;
        const membershipTermMarkup = !this.props.appState.productType ? null :
            !(this.props.appState.productType && this.props.appState.productType.startsWith("EC")) ? null :
                !this.props.appState.yearsInPractice
                    ? (!this.props.appState.rateType ? null
                        : ((this.props.appState.rateType.charAt(this.props.appState.rateType.length - 1) == "1" ||
                            this.props.appState.rateType.charAt(this.props.appState.rateType.length - 1) == "2" ||
                            this.props.appState.rateType.charAt(this.props.appState.rateType.length - 1) == "3") ?
                            <div className={"row" + optOutClass}>
                                <div className={"col-md-12"}>
                                    <div className={"desc"}>
                                        <span>For Term: {current.getMonth() + 1}/{current.getDate()}/{current.getFullYear()} -
                                            12/31/{parseInt(current.getFullYear(), 10) + 3 - parseInt(this.props.appState.rateType.charAt(this.props.appState.rateType.length - 1), 10)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            : null)) : ((this.props.appState.yearsInPractice == 1 ||
                                this.props.appState.yearsInPractice == 2 ||
                                this.props.appState.yearsInPractice == 3) ?
                                <div className={"row" + optOutClass}>
                                    <div className={"col-md-12"}>
                                        <div className={"desc"}>
                                            <span>For Term: {current.getMonth() + 1}/{current.getDate()}/{current.getFullYear()} -
                                                12/31/{parseInt(current.getFullYear(), 10) + 3 - parseInt(this.props.appState.yearsInPractice, 10)}
                                            </span>
                                        </div>
                                    </div>
                                </div> : null);

        const title = this.props.appState.currentStep !== 6 ? <h3>{labels.cart.orderSummary}</h3> : null;

        return <div className={"cart-container"}>
            <SaveAndExitButton saveAndExit={this.props.saveAndExit} currentStep={this.props.appState.currentStep} />
            {title}
            <div className={"item"}>
                <div className={"row"}>
                    <div className={"col-md-8"}>
                        <div className={"desc"}>
                            <span className={"line1"}>{this.props.appState.membershipProductTitleLongName ? this.props.appState.membershipProductTitleLongName : 'Membership'}</span>
                        </div>
                    </div>
                    <div className={"col-md-4"}>
                        <div className={"cost"}>
                            <span>${parseFloat(this.props.appState.membershipPrice)}</span>
                        </div>
                    </div>
                </div>
                {membershipTermMarkup}
            </div>
            {stateComponentMarkup}

            {districtDuesMarkup}

            <div className={"total light-grey"}>
                <div className={"row"}>
                    <div className={"col-md-8"}>
                        <div className={"desc"}>
                            <span className={"line1"}>{labels.cart.total}</span>
                        </div>
                    </div>
                    <div className={"col-md-4"}>
                        <div className={"cost"}>
                            <span>${parseFloat(this.props.appState.priceTotal)}</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>;
    }
}

module.exports = Cart;